import { Directive, HostBinding, Input } from '@angular/core';

type YPosition = 'top' | 'bottom';
type XPosition = 'start' | 'end';

@Directive({
    selector: '[luiResourceCardImageMeta]',
    standalone: false
})
export class ResourceCardImageMetaDirective {
  @HostBinding('class') hostClasses = {
    'resource-card-image-meta': true,
    'resource-card-image-meta-top': false,
    'resource-card-image-meta-bottom': true,
    'resource-card-image-meta-start': false,
    'resource-card-image-meta-end': true,
  };

  @Input() get yPosition(): YPosition {
    return this._yPosition;
  }
  set yPosition(value: YPosition) {
    this.hostClasses = {
      ...this.hostClasses,
      'resource-card-image-meta-top': value === 'top',
      'resource-card-image-meta-bottom': value === 'bottom',
    };

    this._yPosition = value;
  }
  private _yPosition!: YPosition;

  @Input() get xPosition(): XPosition {
    return this._xPosition;
  }
  set xPosition(value: XPosition) {
    this.hostClasses = {
      ...this.hostClasses,
      'resource-card-image-meta-start': value === 'start',
      'resource-card-image-meta-end': value === 'end',
    };

    this._xPosition = value;
  }
  private _xPosition!: XPosition;
}
